import { Card } from 'react-bootstrap-5';
import React from 'react';
import PropTypes from 'prop-types';

export const visualMediaId = visualMediaEmbed => (visualMediaEmbed.id || visualMediaEmbed.tempId);

export function deleteVisualMedia(visualMediaEmbeds, visualMediaIds) {
  return visualMediaEmbeds.reduce((accumulator, visualMediaEmbed) => {
    if (visualMediaIds.includes(visualMediaId(visualMediaEmbed))) {
      if (!Object.hasOwn(visualMediaEmbed, 'tempId')) accumulator.push({ ...visualMediaEmbed, destroy: true });
    } else {
      accumulator.push(visualMediaEmbed);
    }

    return accumulator;
  }, []);
}

export function updateVisualMedia(visualMediaEmbeds, identifier, column, newValue) {
  return visualMediaEmbeds.map((embed) => {
    if (visualMediaId(embed) === identifier) {
      return { ...embed, [column]: newValue };
    }
    return embed;
  });
}

export function NewEmbedUi({
  mediaTypeOptions,
  parentName,
  selectedVisualMediaIds,
  updateVisualMediaEmbed,
  visualMediaEmbeds,
  onBulkCheckboxClick
}) {
  let sortOrder = 0;

  return (
    <React.Fragment>
      {visualMediaEmbeds.map((embed, index) => {
        if (!embed.destroy) {
          sortOrder++;
        }

        const identifier = visualMediaId(embed);
        return (
          <div className={`photo-row ${embed.destroy ? 'hide' : ''}`} key={identifier}>
            <input
              name={`${parentName}[visual_media_embeds_attributes][${index}][sort_order]`}
              type="hidden"
              value={sortOrder}
            />
            {embed.id ? (
              <input
                name={`${parentName}[visual_media_embeds_attributes][${index}][id]`}
                type="hidden"
                value={embed.id}
              />
            ) : null}
            {embed.destroy ? (
              <input
                name={`${parentName}[visual_media_embeds_attributes][${index}][_destroy]`}
                type="hidden"
                value="true"
              />
            ) : null}

            <Card className="visual-media-card">
              <Card.Header className="position-relative">
                <div
                  alt={`Visual Media ${embed.mediaType}`}
                  className={`${embed.embedUrl ? '' : 'empty-photo'} js-photo-preview default-cursor`}
                  style={{ backgroundImage: `url(${embed.fetchThumbnailUrl})` }}
                />
                <div className="menu-container d-flex">
                  <input
                    checked={selectedVisualMediaIds.includes(identifier)}
                    type="checkbox"
                    onChange={() => onBulkCheckboxClick(identifier)}
                  />
                </div>
              </Card.Header>
              <Card.Body>
                <div className="card-body">
                  <input
                    className="form-control"
                    id={`${parentName}-visual-media-requests-embed-${index}`}
                    name={`${parentName}[visual_media_embeds_attributes][${index}][embed_url]`}
                    placeholder="Enter Public URL"
                    value={embed.embedUrl}
                    onChange={e => updateVisualMediaEmbed(identifier, 'embedUrl', e.target.value)}
                  />
                  <select
                    className="form-control select-right-arrow"
                    name={`${parentName}[visual_media_embeds_attributes][${index}][media_type]`}
                    value={embed.mediaType}
                    onChange={e => updateVisualMediaEmbed(identifier, 'mediaType', e.target.value)}
                  >
                    {mediaTypeOptions.map(mediaType => (
                      <option key={mediaType.value} value={mediaType.value}>{mediaType.label}</option>
                    ))}
                  </select>
                </div>
              </Card.Body>
            </Card>
          </div>
        );
      })}
    </React.Fragment>
  );
}

NewEmbedUi.propTypes = {
  mediaTypeOptions: PropTypes.array.isRequired,
  mediaUiUpdate: PropTypes.bool,
  parentName: PropTypes.string.isRequired,
  selectedVisualMediaIds: PropTypes.array.isRequired,
  updateVisualMediaEmbed: PropTypes.func.isRequired,
  visualMediaEmbeds: PropTypes.arrayOf(PropTypes.shape({
    embedUrl: PropTypes.string,
    fetchThumbnailUrl: PropTypes.string,
    mediaType: PropTypes.string,
    id: PropTypes.number,
    sortOrder: PropTypes.number,
  })),
  onBulkCheckboxClick: PropTypes.func.isRequired,
};
